// extracted by mini-css-extract-plugin
export default {"input":"wWdA8","slider":"SF71h","container":"zRYSb","inputWrapper":"dXeJY"};